import { EmailsThemeDto } from "@babackapp/private-api-client/types";
import { calculateContrastColor } from "@babackapp/ui/lib/colors";

export type ThemeContextParent =
  | "background"
  | "card"
  | "primary"
  | "secondary";


export function sectionToParent(section: 'before' | 'after' | 'inside'): ThemeContextParent {
  if (section === 'inside') return 'card';
  return 'background';
}


export function useThemeContextualColors(theme: EmailsThemeDto,	parent: ThemeContextParent) {
  const colorsMap = {
    background: {
      bg: theme.backgroundColor!,
      text: theme.backgroundTextColor!,
      contrast: calculateContrastColor(theme.backgroundColor!),
    },
    card: {
      bg: theme.cardColor!,
      text: theme.cardTextColor!,
      contrast: calculateContrastColor(theme.cardColor!),
    },
    primary: {
      bg: theme.primaryColor!,
      text: theme.primaryTextColor!,
      contrast: calculateContrastColor(theme.primaryColor!),
    },
    secondary: {
      bg: theme.secondaryColor!,
      text: theme.secondaryTextColor!,
      contrast: calculateContrastColor(theme.secondaryColor!),
    },
  }

  return colorsMap[parent];
}

export default useThemeContextualColors;
